"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryErrorBar", {
  enumerable: true,
  get: function () {
    return _victoryErrorbar.default;
  }
});
Object.defineProperty(exports, "ErrorBar", {
  enumerable: true,
  get: function () {
    return _errorBar.default;
  }
});

var _victoryErrorbar = _interopRequireDefault(require("./victory-errorbar"));

var _errorBar = _interopRequireDefault(require("./error-bar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-errorbar/lib/index.js
// module id = 1881
// module chunks = 0